
export enum TipoEquivalenciaEnum {
    NO_MODIFICA_CONCESION = 'NO_MODIFICA_CONCESION',
    MODIFICA_CONCESION = 'MODIFICA_CONCESION',
    MODIFICA_CONCESION_PAYCODE = 'MODIFICA_CONCESION_PAYCODE'
}